import SearchIcon from '@mui/icons-material/Search';
import { Grid, IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
import React from 'react';

import { useIsWidthUp } from '../../utils';

export const AccessGroupMembersListToolbar = (props) => {
    const {
        // tourUserRoles,
        // setRecordListFilters,
        // recordListFilters,
        recordListQuery,
        setRecordListQuery,
        // recordListOptions 
    } = props;

    // const numberOfGuests = recordListOptions.filter(user => user.roles?.length === 0)?.length
    // const allCount = recordListOptions.length
    // const numberOfAdmins = recordListOptions.filter(user => user.roles.filter(role => role === 10)?.length > 0)?.length
    // const numberOfTourGuides = recordListOptions.filter(user => user.roles.filter(role => role === 11)?.length > 0)?.length

    const isSmallScreen = !useIsWidthUp('sm')


    // const handleRoleFilterSelect = (role) => {
    //     setRecordListFilters(prev => {
    //         let new_roles = [...prev]
    //         if (prev.filter(r => r === role).length > 0) {
    //             new_roles = prev.filter(r => r !== role)
    //             return new_roles;
    //         }
    //         return [...prev, role]
    //     })
    // };

    return (
        <Grid item xs={12} container p={1} pt={2} px={2} >
            <Grid item container xs={12} sm={6} direction="row" alignItems="center" pb={isSmallScreen ? 2 : 0}>
                <TextField
                    color="primary"
                    size="small"
                    variant="filled"
                    fullWidth
                    label="Search"
                    style={{ maxWidth: '400px' }}
                    value={recordListQuery || ''}
                    onChange={(ev) => setRecordListQuery(ev.target.value)}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <Tooltip title="Search">
                                    <IconButton aria-label="do search">
                                        <SearchIcon />
                                    </IconButton>
                                </Tooltip>
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            {/* <Grid item xs={12} sm={6} container justifyContent="flex-end" alignItems="center">
                <Grid className={isSmallScreen && 'hide-scrollbar'} style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'space-between', gap: '0.5rem', overflow: 'auto', maxWidth: '92vw' }}>
                    <Grid
                        item
                        xs={'auto'}
                        style={{
                            padding: '6px 16px',
                            borderRadius: '16px',
                            backgroundColor: recordListFilters.length === 0 ? theme.palette.primary.main : '#D8D8D8',
                            color: recordListFilters.length === 0 ? '#D8D8D8' : 'rgba(0, 0, 0, 0.87)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            border: 'solid 1px lightgrey',
                            height: '32px',
                        }}
                        key={recordListFilters ? recordListFilters?.length + 1 : null}
                        onClick={(ev) => setRecordListFilters([])}
                    >
                        <Typography>All ({allCount})</Typography>
                    </Grid>
                    {tourUserRoles.map((role) => {
                        return (
                            <Grid
                                item
                                xs={'auto'}
                                style={{
                                    padding: '6px 16px',
                                    borderRadius: '16px',
                                    height: '32px',
                                    backgroundColor: recordListFilters?.includes(role.id) ? theme.palette.primary.main : '#D8D8D8',
                                    color: recordListFilters?.includes(role.id) ? '#D8D8D8' : 'rgba(0, 0, 0, 0.87)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    border: 'solid 1px lightgrey',
                                    textTransform: 'capitalize',
                                }}
                                key={role.id}
                                onClick={(ev) => handleRoleFilterSelect(role.id)}
                            >
                                {role.id ? (
                                    <Typography>
                                        {role.name} {role.id === 10 && `(${numberOfAdmins})`} {role.id === 11 && `(${numberOfTourGuides})`}
                                    </Typography>
                                ) : (
                                    <Typography>Guest ({numberOfGuests}) </Typography>
                                )}
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid> */}
        </Grid>
    );
};

export default AccessGroupMembersListToolbar;
